import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// PrimeNG Modules
import { ButtonModule } from 'primeng/button';
import { PanelModule } from 'primeng/panel';
import { ChartModule } from 'primeng/chart';
import { TabsModule } from 'primeng/tabs';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { TableModule } from 'primeng/table';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { TagModule } from 'primeng/tag';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MenuModule } from 'primeng/menu';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { ChipModule } from 'primeng/chip';
import { KnobModule } from 'primeng/knob';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MessageModule } from 'primeng/message';

import { CheckboxModule } from 'primeng/checkbox';
import { ToggleSwitchModule } from 'primeng/toggleswitch';


// Components & Pipes
import { GridComponent } from './components/grid/grid.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TranslateDirective } from '@ngx-translate/core';
import { ColumnFilterValueListComponent } from './components/column-filter-value-list/column-filter-value-list.component';
import { ColumnFilterSpaceZoneComponent } from './components/column-filter-space-zone/column-filter-space-zone.component';
import { FullnamePipe } from './pipes/fullname.pipe';
import { ContrastColorPipe } from './pipes/contrast-color.pipe';
import { GridColumnDataPipe } from './pipes/grid-column-data.pipe';
import { NumericDataBarComponent } from './components/numeric-data-bar/numeric-data-bar.component';
import { AlertDialogComponent } from './components/alert-dialog/alert-dialog.component';
import { AclDialogComponent } from './components/acl-dialog/acl-dialog.component';
import { DocumentsService } from './services/documents.service';

import { TagSelectorComponent } from './components/tag-selector/tag-selector.component';

@NgModule({
  declarations: [
    GridComponent,
    ColumnFilterValueListComponent,
    ColumnFilterSpaceZoneComponent,
    FullnamePipe,
    ContrastColorPipe,
    GridColumnDataPipe,
    NumericDataBarComponent,
    AlertDialogComponent,
    AclDialogComponent,
    TagSelectorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ButtonModule,
    PanelModule,
    ChartModule,
    TabsModule,
    BadgeModule,
    OverlayBadgeModule,
    TableModule,
    IconFieldModule,
    InputIconModule,
    TagModule,
    InputTextModule,
    MultiSelectModule,
    SelectModule,
    CalendarModule,
    TranslatePipe,
    TranslateDirective,
    SplitButtonModule,
    MenuModule,
    ToastModule,
    TooltipModule,
    ChipModule,
    KnobModule,
    DialogModule,
    ConfirmDialogModule,
    CheckboxModule, 
    ToggleSwitchModule,
    MessageModule
,
    FileUploadModule,
    AutoCompleteModule,
    DropdownModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    PanelModule,
    ChartModule,
    TabsModule,
    BadgeModule,
    OverlayBadgeModule,
    TableModule,
    IconFieldModule,
    InputIconModule,
    TagModule,
    InputTextModule,
    MultiSelectModule,
    SelectModule,
    GridComponent,
    SplitButtonModule,
    MenuModule,
    ColumnFilterValueListComponent,
    ColumnFilterSpaceZoneComponent,
    ColumnFilterSpaceZoneComponent,
    ToastModule,
    FullnamePipe,
    ContrastColorPipe,
    GridColumnDataPipe,
    TooltipModule,
    ChipModule,
    KnobModule,
    DialogModule,
    NumericDataBarComponent,
    AlertDialogComponent,
    AclDialogComponent,
    ConfirmDialogModule,
    FileUploadModule,
    CheckboxModule,
    ToggleSwitchModule,
    AutoCompleteModule,
    TagSelectorComponent,
    MessageModule,
    DropdownModule,
    CalendarModule
  ],
  providers: [FullnamePipe, ContrastColorPipe, GridColumnDataPipe, DatePipe, DocumentsService]
})
export class SharedModule { }
